export class FormulaireRepondu {
    id = 0
    idModeleFormulaire = 0
    reponses: FormulaireRepondu_Reponse[] = []
}

export class FormulaireRepondu_Reponse {
    idQuestion = 0
    reponse = ''
}
